// extracted by mini-css-extract-plugin
module.exports = {"card_hover":"PowerBilling_card_hover__3uCYV","configuration":"PowerBilling_configuration__1BsCV"};